import React from "react";
import { withRouter } from "react-router-dom";
import { Box } from "./style";
import Modal from "./modal";
import { getToken } from "../../../../lib/tokenManager";
import { Confirm } from "../../../../components/confirm";
import { isEqual } from "lodash";
import message from "./component/message";
class Index extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      modalStatus: false,
      currentShow: 0,
      overFlowStandardFeatureMessageShow: false,
      overFlowStandardFeatureMessage: ""
    };
  }
  componentDidMount() {
    const { limitConstants } = this.props;
    if (limitConstants) {
      const noticeMessage = message(limitConstants);
      if (noticeMessage) {
        this.setState({
          overFlowStandardFeatureMessageShow: true,
          overFlowStandardFeatureMessage: noticeMessage
        });
      }
    }
  }

  componentDidUpdate() {
    if (!this.props.files.length && this.state.modalStatus) {
      this.setState({
        modalStatus: false
      });
    }
  }
  shouldComponentUpdate(nextProps, nextState) {
    return (
      !isEqual(nextState, this.state) ||
      !isEqual(nextProps.files, this.props.files)
    );
  }
  inputView() {
    let files = this.props.files;
    const { overFlowStandardFeatureMessageShow } = this.state;
    return (
      <React.Fragment>
        <Confirm
          show={this.state.modalShow}
          content={{
            type: "danger",
            icon: "icon mapsa-notification",
            message: this.state.modalMessage,
            rejectButtonText: "باشه"
          }}
          rejectHandler={() => {
            this.setState({ modalShow: false });
          }}
          close={() => this.setState({ modalShow: false })}
        />
        <input
          type="file"
          name="file"
          id="file"
          className="input-file"
          onClick={e => {
            if (overFlowStandardFeatureMessageShow) {
              e.preventDefault();
            }
          }}
          onChange={e => {
            if (this.props.accept.indexOf(e.target.files[0]["type"]) >= 0) {
              if (e.target.files[0]["size"] < 3145728) {
                this.props.change("files", files.concat(e.target.files[0]));
              } else {
                this.setState({
                  modalShow: true,
                  modalMessage: "حجم فایل ارسالی بیش از 3 مگابایت است."
                });
                return false;
              }
            } else {
              this.setState({
                modalShow: true,
                modalMessage: "فرمت فایل ارسالی مجاز نمی‌باشد و تنها بارگذاری فایل‌های JPEG, JPG و PNG مجاز است."
              });
              return false;
            }
            return false;
          }}
          accept={this.props.accept}
        />
      </React.Fragment>
    );
  }
  bigAdd() {
    let files = this.props.files;
    const { overFlowStandardFeatureMessageShow } = this.state;
    if (files && files.length < this.props.limit) {
      return (
        <React.Fragment>
          {this.inputView()}
          <label
            htmlFor="file"
            className={`add-file-big ${
              overFlowStandardFeatureMessageShow ? "disable" : ""
            }`}
          >
            <i className="icon mapsa-plus" />
          </label>
        </React.Fragment>
      );
    }
  }
  remove(index) {
    let files = this.props.files;
    let deleted_image_ids = this.props.deleted_image_ids;
    let result = [];
    if (files) {
      files.forEach((item, i) => {
        if (i !== index) {
          result.push(item);
        }
      });
    }
    if (files[index] && files[index]["id"]) {
      deleted_image_ids.push(files[index]["id"]);
      this.props.change("deleted_image_ids", deleted_image_ids);
    }
    this.props.change("files", result);
    this.setState({
      currentShow: index - 1
    });
  }
  modalView() {
    if (this.state.modalStatus) {
      return (
        <Modal
          files={this.props.files}
          current={this.state.currentShow}
          remove={i => {
            this.remove(i);
          }}
          close={() => {
            this.setState({
              modalStatus: false
            });
          }}
        />
      );
    }
  }
  src(file) {
    if (file.id) {
      return (
        process.env.REACT_APP_API_URL +
        "/projects/" +
        localStorage.getItem("project_id") +
        "/imagesWeb/" +
        file.id +
        "?access_token=" +
        getToken("accessToken")
      );
    } else {
      return window.URL.createObjectURL(file);
    }
  }
  imagesView(files) {
    const {
      overFlowStandardFeatureMessageShow,
      overFlowStandardFeatureMessage
    } = this.state;
    return (
      <Box>
        <div className="files">
          {files.map((file, i) => (
            <div
              className="file"
              key={i}
              style={{
                backgroundImage: `url(${this.src(file)})`
              }}
              onClick={() => {
                this.setState({
                  modalStatus: true,
                  currentShow: i
                });
              }}
            >
              <i
                className="icon mapsa-trash"
                onClick={e => {
                  e.stopPropagation();
                  this.remove(i);
                }}
              />
            </div>
          ))}
          {this.bigAdd()}
        </div>
        {this.modalView()}
        {overFlowStandardFeatureMessageShow && (
          <div className="file-notice">
            <i className="icon mapsa-info" />
            <div>{overFlowStandardFeatureMessage}</div>
          </div>
        )}
      </Box>
    );
  }
  render() {
    const { files } = this.props;
    const {
      overFlowStandardFeatureMessageShow,
      overFlowStandardFeatureMessage
    } = this.state;
    if (!files || files.length <= 0) {
      return (
        <Box>
          {this.inputView()}
          <label
            htmlFor="file"
            className={`add-file ${
              overFlowStandardFeatureMessageShow ? "disable" : ""
            }`}
          >
            افزودن پیوست
          </label>
          {overFlowStandardFeatureMessageShow && (
            <div className="file-notice">
              <i className="icon mapsa-info" />
              <div>{overFlowStandardFeatureMessage}</div>
            </div>
          )}
        </Box>
      );
    } else {
      return this.imagesView(files);
    }
  }
}

export default withRouter(Index);
